import { createAction, props } from '@ngrx/store';

import { SearchFilterLabelsEntity } from './search-filter-labels.models';

export const loadOptionLabels = createAction('[OptionLabels/API] Load OptionLabels');

export const loadOptionLabelsSuccess = createAction(
  '[OptionLabels/API] Load OptionLabels Success',
  props<{ optionLabels: SearchFilterLabelsEntity[] }>()
);

export const loadOptionLabelsFailure = createAction(
  '[OptionLabels/API] Load OptionLabels Failure',
  props<{ error: any }>()
);

export const loadExhibitorFilterLabel = createAction(
  '[OptionLabels/API] Load SearchFilterLabel for Exhibitor',
  props<{ exhibitorId: string }>()
);

export const loadExhibitorFilterLabelSuccess = createAction(
  '[OptionLabels/API] Load Exhibitor Filter Label Success',
  props<{ exhibitorFilterLabel: SearchFilterLabelsEntity }>()
);

export const loadExhibitorFilterLabelFailure = createAction(
  '[OptionLabels/API] Load Exhibitor Filter Label Failure',
  props<{ error: any }>()
);

export const removeExhibitorFilterLabel = createAction('[OptionLabels/API] Remove SearchFilterLabel for Exhibitor');
